import React from 'react';
import styles from './Card.module.css';

export default function Card({ title, action, noPadding = false, id, children, className }) {
  return (
    <div className={`${styles.card} ${className || ''}`} id={id}>
      {title && (
        <div className={styles.header}>
          <span className={styles.title}>{title}</span>
          {action && <div className={styles.action}>{action}</div>}
        </div>
      )}
      <div className={noPadding ? styles.bodyFlush : styles.body}>
        {children}
      </div>
    </div>
  );
}
